import React from 'react';
import { useTranslation } from 'react-i18next';
import './DraftPill.scss';

const DraftPill = ({ hideTextVersion = false, version }) => {
  const { t } = useTranslation();
  return version ? (
    <div className="in-progress-pill" data-testid="draft-pill">
      {!hideTextVersion && version > 1
        ? t('versionInProgress', { version })
        : t('inProgress')}
    </div>
  ) : null;
};

export default DraftPill;

export const DraftPillClientView = () => {
  const { t } = useTranslation();
  return (
    <div className="draft-pill" data-testid="draft-pill">
      {t('draft')}
    </div>
  );
};
